import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import { IconButton, Tooltip } from '@material-ui/core'
import { Edit, Delete, Stop } from '@material-ui/icons'
import Moment from 'react-moment'
import { AdminUsersContainer } from './styled'
import { AdminContainer } from '../../styled'
import { rootPath, adminPath, configPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'
import { getAdminUsers } from 'ducks/system'
import AdminUserModal from './FormModal'

const AdminUsers = (props) => {
  const { user, history, listAdminUsers } = props

  useEffect(() => {
    if (listAdminUsers.data.length === 0 && listAdminUsers.loading === false) {
      props.getAdminUsers()
    }
  }, [])

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const [showModal, setShowModal] = useState(false)
  const [editData, setEditData] = useState(undefined)

  const columns = [
    {
      Header: '',
      accessor: 'id',
      width: 50,
      Cell: row => (
        <div className='actionsContent'>
          <Tooltip title='Edit'>
            <IconButton 
              style={{ padding: '10px' }}
              onClick={() => {
                setEditData(row.original)
                setShowModal(true)
              }}
            >
              <Edit style={{ fontSize: '1rem' }} />
            </IconButton>
          </Tooltip>
        </div>
      )
    }, {
      Header: 'Status',
      accessor: 'status',
      width: 80,
      Cell: row => (
        <div style={{ 
          color: row.value === 'Active' ? 'green' : row.value === 'Inactive' ? 'red' : 'inherit' 
        }}>{row.value}</div>
      )
    }, {
      Header: 'Name',
      accessor: 'name',
      width: 300,
      Cell: row => row.value ? row.value : row.original.username
    }, {
      Header: 'Effective From',
      accessor: 'effectiveDateStart',
      style: { textAlign: 'center' },
      width: 130,
      Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-')
    }, {
      Header: 'Effective To',
      accessor: 'effectiveDateEnd',
      style: { textAlign: 'center' },
      width: 130,
      Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-')
    }, {
      Header: 'Note',
      accessor: 'note',
      style: { textAlign: 'center' },
      Cell: row => row.value ? row.value : '-'
    }
  ]

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Admin Users</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'Config', content: 'Configuration', link: true, onClick: () => history.push(configPath) },
              { key: 'AdminUsers', content: 'Admin Users', active: true }
            ]
          }
        />
      </div>
      <AdminUsersContainer>
        <Button
          type='button'
          content='Create'
          color='blue'
          icon='plus'
          labelPosition='right'
          style={{ marginBottom: '5px' }}
          onClick={() => setShowModal(true)}
        />
        <ReactTable
          data={listAdminUsers.data}
          columns={columns}
          sortable={false}
        />
      </AdminUsersContainer>
      {showModal ? <AdminUserModal setShowModal={setShowModal} data={editData} /> : null}
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
    listAdminUsers: state.system.listAdminUsers
  })
}

const mapDispatchToProps = {
  toggleSideMenu,
  getAdminUsers
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsers)